<template>
    <div class="apply"> 
        <div class="nav">
            <router-link to="/pilotage" tag="span" class="active">领航研服务</router-link>
            <router-link to="/pilotagelist"  tag="span">案例库</router-link>
        </div>
        <!-- banner -->
        <div class="banner">
            
        </div>
        <!-- 服务特色 -->
        <div class="service">
            <p class="title">服务特色</p> 
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-renshengjieduan"></span>
                </div>
                <div class="right">
                    <p class="li_title">阶段式教学</p>
                    <p class="content">全辅导过程以学长专业课1V1指导为核心，通过提供知识点精讲、重难点专题精讲、历年真题解析与应试技巧指导等，指导专业课学习。全流程服务包括考研战略指导、学长专业课1V1指导、阶段性模拟测试、复试及调剂咨询等，每个阶段既独立又统一，全面提升考研上岸率。</p>
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-xinxi"></span>
                </div>
                <div class="right">
                    <p class="li_title">内部信息和资料</p>
                    <p class="content">通过直系学长/学姐一对一辅导，由考研上岸的学长/学姐提供更新、更有用的内部信息和资料，解决考研专业课缺乏的信息、资料的问题，避免复习时抓错重点、用错资料。</p>
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-tuandui"></span>
                </div>
                <div class="right">
                    <p class="li_title">专业授课团队</p>
                    <p class="content">专业课授课团队全部来自往年同院校、同专业上岸的直系学长/学姐，经过严格的海选、初筛、面试、笔试、试讲、录用、培训7大环节后方可授课，确保专业课辅导效果。</p>
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-fuwu"></span>
                </div>
                <div class="right">
                    <p class="li_title">全程跟踪服务</p>
                    <p class="content">从签署服务协议开始，每位学生将配备咨询顾问、专业课1V1领航导师、全程班主任。确保授课前进行针对性备课、授课时全程督学、授课后回访跟进，保障服务质量。</p>
                </div>
            </div>
            <div class="li">
                <div class="left">
                    <span class="iconfont icon-zidianyingshedui"></span>
                </div>
                <div class="right">
                    <p class="li_title">1对1定制服务</p>
                    <p class="content">1对1定制学习辅导方案，确保每位考生都能获得老师的全面关注。同时，全程采用在线授课方式，学生足不出户即可获得更专业的考研专业课辅导，更省时更高效。</p>
                </div>
            </div>
        </div>

        <!-- 领航研导师库 -->
        <div class="teacher">
            <p class="title"><span>领航研导师库</span> <span @click="goTeacher">查看更多 ></span></p>
            <ul>
                <li v-for="(item,index) in teacherList" :key="index">
                    <div class="left">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="right">
                        <p class="name">{{item.name}} <span>{{item.label}}</span></p>
                        <p class="info">{{item.info}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <!--  -->
        <div class="serviceImg">
            <img src="@/assets/img/pilotage/service_01.jpg" alt="">
            <img src="@/assets/img/pilotage/service_02.jpg" alt="">
            <img src="@/assets/img/pilotage/service_03.jpg" alt="">
        </div>

        
        <div class="button">
            <p @click="isShow = true">免费咨询</p>
        </div>

        <!-- 遮罩 -->
        <van-overlay :show="isShow" default @click="isShow = false">
            <div class="wrapper" @click.stop>
                <div class="mask">
                    <p>识别二维码免费咨询</p>
                    <img src="@/assets/img/pilotage/ewm.jpg" alt="">
                    <span class="iconfont icon-guanbi" @click="isShow = false"></span>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>

export default {
    data() {
        return {
            isShow:false,
            teacherList:[{
                name:"婷婷学姐",
                img:require("@/assets/img/pilotage/ting.jpg"),
                label:"清华大学硕士",
                info:"2017年清华大学美术学院艺术硕士考研上岸，总分364分，初试全国第一名。十分熟悉清华美院各专业报考难度，擅长专业课应试技巧。2017年9月加入领航研，对考生进行一对一美术理论和手绘专业课辅导。辅导的四位同学中：2018年辅导的三位同学，均顺利通过清华美院考研初试（具体见案例），并包揽2018年清华美院艺术硕士全国第一、第二名；另一位同学于2019年一战上岸清华美院。"
            },{
                name:"Frank学长",
                img:require("@/assets/img/pilotage/frank.jpg"),
                label:"清华大学硕士",
                info:"2018年考研，清华大学法学院法学硕士录取，初试成绩340+分，复试成绩93分。初试复习三个月，复试复习一个月，复试成绩为本专业第一。曾担任知名教育机构法学考研全程班讲师。熟悉老师的授课内容与本学科出题热点，擅长指导考生在短期内有的放矢地复习，在复试中取得逆袭。"
            }]
        }
    },
    methods:{
        goList(){
            // this.$router.push({
            //     path: "/pilotagelist"
            // })
        },
        goTeacher(){
            this.$router.push({
                path: "/pilotageteacher"
            })
            window.scrollTo({
                top: 0,
                // behavior: "smooth"
            });
        },
    },
    mounted(){
    },
    beforeDestroy(){
    }
}
</script>

<style lang="less" scoped>
.apply {
    background:#fff;
    padding-bottom:150px;
    // font-family: 'PingFang Regular';

    //nav
    .nav {
        height: 90px;
        border-bottom: 1px solid #E6E6E6;

        span {
            font-size: 32px;
            color: #192533;
            width: 50%;
            text-align: center;
            line-height: 90px;
            display: inline-block;
            font-weight: 600;
        }
        .active {
            color: #da1f1f;
            position: relative;
        }
        .active:before {
            border-bottom: 5px solid #da1f1f;
            bottom: 0;
            content: "";
            display: inline-block;
            left: calc(50% - 25px);
            position: absolute;
            width: 50px;
        }
    }
    .banner {
        width: 100%;
        height: 360px;
        position: relative;
        background:url("../../assets/img/pilotage/apply_banner.jpg") no-repeat;
        background-size: auto 100%;
        background-position: center 0;
        p {
            padding-top: 125px;
            text-align: center;
            font-size: 47px;
            color: #fff;
            span {
                color: #da1f1f;
            }
        }
        .img {
            width: 170px;
            // height: 38px;
            position: absolute;
            top: 40px;
            left: 43px;
            img {
                width: 100%;
                // height: 100%;
            }
        }
    }
    .service{
       .title{
           text-align: center;
           color:#da1f1f;
           font-size: 38px;
           padding:60px 0 70px;
           line-height: 38px;
           font-weight: 600;
       }
       .li{
           padding:0 35px;
           display: flex;
           margin-bottom:80px;
           .left{
               width:70px;
               margin-right:30px;
               span{
                   display: inline-block;
                   color:#da1f1f;
                   font-size: 70px;
                   line-height: 54px;
               }
                .icon-renshengjieduan{
                    font-size: 60px;
                }
           }
           .right{
               flex:1;
               .li_title{
                   font-size: 32px;
                   color:#020202;
                   font-weight: 600;
                   margin-bottom:30px;
                   line-height: 32px;
               }
               .content,.info{
                   font-size: 28px;
                   color:#4D4D4D;
                   line-height:50px;
               }
               .info{
                   padding-left:37px;
                   position: relative;
                   &::before{
                        content:"";
                        width:7px;
                        height:7px;
                        background:rgba(77,77,77,1);
                        border-radius:50%;
                        position: absolute;
                        left: 0;
                        top:50%;
                        transform: translateY(-50%);
                   }
               }
               img{
                   width:421px;
                   margin-top:30px;
               }
           }
       }
    }
    .button{
        width:100%;
        height:170px;
        background:#fff;
        padding-top:20px;
        position: fixed;
        bottom:0px;
        left: 0;
        p{
            width:521px;
            height:88px;
            background: linear-gradient(0deg, #ff5e29, #ea1001);
            border-radius:44px;
            text-align: center;
            line-height: 88px;
            color:#fff;
            font-size: 32px;
            margin:0 auto;
        }
    }
    .teacher{
        border-top:20px solid #F5F5F5;
        padding:0 25px;
        .title{
            color:#da1f1f;
            font-size: 38px;
            padding:60px 0px 70px;
            line-height: 38px;
            span{
                color:#1E6BB8;
                font-size:28px;
                float:right;
                margin-top:2px;
            }
            span:first-child{
                color:#da1f1f;
                font-size: 38px;
                font-weight: 600;
                float:left;
            }
        }
        ul{
            // margin-top:20px;
            li{
                border:1px solid rgba(204,204,204,1);
                border-radius:20px;
                margin-bottom:20px;
                display:flex;
                padding:37px 28px;
                .left{
                    width:114px;
                    height:114px;
                    background:#ddd;
                    margin-right:30px;
                    img{
                        width:100%;
                        height:100%;
                    }
                }
                .right{
                    flex:1;
                    .name{
                        font-size:32px;
                        color:#000000;
                        span{
                            display:inline-block;
                            padding:0px 15px;
                            border-radius:17px;
                            background:#da1f1f;
                            color:#fff;
                            font-size:24px;
                            line-height:32px;
                            margin-left:15px;
                            vertical-align: middle;
                            margin-top:-10px;
                        }
                    }
                    .info{
                        margin-top:20px;
                        font-size:26px;
                        color:#4D4D4D;
                        line-height:44px;
                    }
                }
            }
        }
    }
    .serviceImg{
        img{
            width:100%;
            display: block;
        }
    }
    // 遮罩
    .van-overlay {
        z-index: 2000 !important;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .mask {
            width: 600px;
            border-radius: 20px;
            padding: 80px 0px 80px;
            background: #fff;
            box-sizing: border-box;
            text-align: center;
            position: relative;
            margin-bottom: 100px;
            font-family: 'PingFang Regular';
            background: #f7faff;
            img {
                width: 350px;
                height: 350px;
                margin-top: 20px;
            }
            p {
                font-size: 30px;
                color: #2d2d2d;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .name {
                font-size: 26px;
            }
            .iconfont {
                display: block;
                position: absolute;
                width: 60px;
                height: 60px;
                color: #fff;
                text-align: center;
                margin: 40px auto 0;
                font-size: 40px;
                line-height: 60px;
                border: 1px solid #fff;
                border-radius: 50%;
                bottom: -100px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
    }
}
</style>